import type {
  Notification,
  NotificationType,
} from "@/common/types/notification";
import type { Ref } from "vue";
import { ref } from "vue";

const DEFAULT_DISMISSIBLE = true;
const DEFAULT_TIMEOUT = 6000;

let notificationCounter = 0;

const queue: Ref<Array<Notification>> = ref([]);

const push = (
  type: NotificationType,
  message?: string,
  title?: string,
  dismissible = DEFAULT_DISMISSIBLE,
  timeout = DEFAULT_TIMEOUT,
) => {
  const id = String(notificationCounter++);

  queue.value.push({
    id: id,
    type: type,
    title: title,
    message: message,
    dismissible: dismissible,
    timeout: timeout,
  });

  setTimeout(() => {
    console.log("Exec remove callback");
    remove(id);
  }, timeout);
};

const remove = (id: string) => {
  console.log("Attempting to remove notification", id);

  queue.value = queue.value.filter((notification) => notification.id !== id);
};

export const useNotifications = (): {
  queue: typeof queue;
  push: typeof push;
  remove: typeof remove;
} => {
  return { queue, push, remove };
};
